@if (initialized) {
  <div>
    <!-- Labor -->
    <div class="mat-body-strong">{{reportLabor.quantity}} {{reportLabor.type}} <!-- (Jerdon, 11 hours) --></div>
    @if (reportLabor.comment) {
      <div class="mat-caption">{{reportLabor.comment}}</div>
    }
    <!-- /Labor -->
  </div>
}
